/**
 * This is a mapping of the role ids to the role names and alt names.
 * The alt name is used in Replay to say "You are a/an [alt name] magician"
 */
export const roleMapping: Record<string, { name: string; altName: string; plural: string }> = {
  2: {
    name: 'Client',
    altName: 'client',
    plural: 'clients',
  },
  6: {
    name: 'Production Company',
    altName: 'production company',
    plural: 'production companies',
  },
  7: {
    name: 'Brand',
    altName: 'brand',
    plural: 'brands',
  },
  8: {
    name: 'Agency',
    altName: 'agency',
    plural: 'agencies',
  },
  9: {
    name: 'Partner',
    altName: 'partner',
    plural: 'partners',
  },
  10: {
    name: 'Sponsor',
    altName: 'sponsor',
    plural: 'sponsors',
  },
  12: {
    name: 'Executive Producer',
    altName: 'executive producing',
    plural: 'executive producers',
  },
  13: {
    name: 'Producer',
    altName: 'producing',
    plural: 'producers',
  },
  14: {
    name: 'Director',
    altName: 'directing',
    plural: 'directors',
  },
  15: {
    name: 'Creative Director',
    altName: 'creative directing',
    plural: 'creative directors',
  },
  16: {
    name: 'Director of Photography',
    altName: 'photography directing',
    plural: 'directors of photography',
  },
  17: {
    name: 'Location Manager',
    altName: 'location management',
    plural: 'location managers',
  },
  18: {
    name: 'Production Designer',
    altName: 'production design',
    plural: 'production designers',
  },
  19: {
    name: 'Writer/Author',
    altName: 'writing',
    plural: 'writers/authors',
  },
  20: {
    name: 'Copywriter',
    altName: 'copywriting',
    plural: 'copywriters',
  },
  21: {
    name: 'Art Director',
    altName: 'art direction',
    plural: 'art directors',
  },
  22: {
    name: 'Cinematographer',
    altName: 'cinematography',
    plural: 'cinematographers',
  },
  23: {
    name: 'Lighting Director',
    altName: 'lighting direction',
    plural: 'lighting directors',
  },
  24: {
    name: 'Photographer',
    altName: 'photography',
    plural: 'photographers',
  },
  25: {
    name: 'Videographer',
    altName: 'videography',
    plural: 'videographers',
  },
  26: {
    name: 'Camera Operator',
    altName: 'camera operation',
    plural: 'camera operators',
  },
  27: {
    name: 'Drone Pilot',
    altName: 'drone piloting',
    plural: 'drone pilots',
  },
  28: {
    name: 'Editor',
    altName: 'editing',
    plural: 'editors',
  },
  29: {
    name: 'VFX Artist',
    altName: 'VFX',
    plural: 'VFX artists',
  },
  30: {
    name: 'Illustrator',
    altName: 'illustration',
    plural: 'illustrators',
  },
  31: {
    name: 'Animator - 2D',
    altName: '2D animation',
    plural: '2D animators',
  },
  32: {
    name: 'Actor',
    altName: 'acting',
    plural: 'actors',
  },
  33: {
    name: 'Actress',
    altName: 'acting',
    plural: 'actresses',
  },
  34: {
    name: 'Talent',
    altName: 'talent',
    plural: 'talents',
  },
  35: {
    name: 'Audio Designer',
    altName: 'audio design',
    plural: 'audio designers',
  },
  36: {
    name: 'Costume Designer',
    altName: 'costume design',
    plural: 'costume designers',
  },
  37: {
    name: 'Designer',
    altName: 'design',
    plural: 'designers',
  },
  38: {
    name: 'Makeup',
    altName: 'makeup',
    plural: 'makeup artists',
  },
  39: {
    name: 'Production Assistant',
    altName: 'production assisting',
    plural: 'production assistants',
  },
  40: {
    name: 'Grip',
    altName: 'grip',
    plural: 'grips',
  },
  41: {
    name: 'Gaffer',
    altName: 'gaffing',
    plural: 'gaffers',
  },
  42: {
    name: 'Boom Operator',
    altName: 'boom operation',
    plural: 'boom operators',
  },
  43: {
    name: 'Subtitler',
    altName: 'subtitling',
    plural: 'subtitlers',
  },
  45: {
    name: 'Graphic Artist',
    altName: 'graphic art',
    plural: 'graphic artists',
  },
  46: {
    name: 'Fabricator',
    altName: 'fabrication',
    plural: 'fabricators',
  },
  47: {
    name: 'Publisher',
    altName: 'publishing',
    plural: 'publishers',
  },
  48: {
    name: 'Technology',
    altName: 'technology',
    plural: 'technologies',
  },
  49: {
    name: 'Creator',
    altName: 'content creation',
    plural: 'creators',
  },
  50: {
    name: 'Stock Photography',
    altName: 'stock photography',
    plural: 'stock photographers',
  },
  51: {
    name: 'Social Manager',
    altName: 'social media',
    plural: 'social managers',
  },
  52: {
    name: 'Sports Team',
    altName: 'sports team',
    plural: 'sports teams',
  },
  53: {
    name: 'Sports League',
    altName: 'sports league',
    plural: 'sports leagues',
  },
  54: {
    name: 'Graphic Designer',
    altName: 'graphic design',
    plural: 'graphic designers',
  },
  55: {
    name: 'Content Strategist',
    altName: 'content strategy',
    plural: 'content strategists',
  },
  56: {
    name: 'Content Producer',
    altName: 'content production',
    plural: 'content producers',
  },
  57: {
    name: 'Social Agency',
    altName: 'social agency',
    plural: 'social agencies',
  },
  58: {
    name: 'Creative Agency',
    altName: 'creative agency',
    plural: 'creative agencies',
  },
  59: {
    name: 'Athlete',
    altName: 'athlete',
    plural: 'athletes',
  },
  60: {
    name: 'CGI Artist',
    altName: 'CGI',
    plural: 'CGI artists',
  },
  61: {
    name: 'Music Editor',
    altName: 'music editing',
    plural: 'music editors',
  },
  62: {
    name: 'Voice Over Artist',
    altName: 'voice over',
    plural: 'voice over artists',
  },
  63: {
    name: 'Sports Information Director',
    altName: 'sports information direction',
    plural: 'sports information directors',
  },
  64: {
    name: 'Motion Designer',
    altName: 'motion design',
    plural: 'motion designers',
  },
  65: {
    name: 'Non-Profit Organization',
    altName: 'non-profit',
    plural: 'non-profit organizations',
  },
  66: {
    name: 'Media Company',
    altName: 'media',
    plural: 'media companies',
  },
  67: {
    name: 'Event Promoter',
    altName: 'event',
    plural: 'event promoters',
  },
  68: {
    name: 'Government Organization',
    altName: 'government',
    plural: 'government organizations',
  },
  69: {
    name: 'Collective/Community',
    altName: 'community',
    plural: 'collectives/communities',
  },
  70: {
    name: 'Venue',
    altName: 'venue',
    plural: 'venues',
  },
  71: {
    name: 'Talent Agency',
    altName: 'talent agency',
    plural: 'talent agencies',
  },
  72: {
    name: 'Script Supervisor',
    altName: 'script supervision',
    plural: 'script supervisors',
  },
  73: {
    name: 'Story Producer',
    altName: 'story production',
    plural: 'story producers',
  },
  74: {
    name: 'Script Editor',
    altName: 'script editing',
    plural: 'script editors',
  },
  75: {
    name: 'Script Coordinator',
    altName: 'script coordination',
    plural: 'script coordinators',
  },
  76: {
    name: 'Screenwriter',
    altName: 'screenwriting',
    plural: 'screenwriters',
  },
  77: {
    name: 'Storyboard Artist',
    altName: 'storyboard art',
    plural: 'storyboard artists',
  },
  78: {
    name: 'Location Assistant',
    altName: 'location assistance',
    plural: 'location assistants',
  },
  79: {
    name: 'Location Scout',
    altName: 'location scouting',
    plural: 'location scouts',
  },
  80: {
    name: 'Line Producer',
    altName: 'line production',
    plural: 'line producers',
  },
  81: {
    name: 'Production Secretary',
    altName: 'production secretary',
    plural: 'production secretaries',
  },
  82: {
    name: 'Production Accountant',
    altName: 'production accounting',
    plural: 'production accountants',
  },
  83: {
    name: 'Account Manager',
    altName: 'account management',
    plural: 'account managers',
  },
  84: {
    name: 'Social Media Manager',
    altName: 'social media management',
    plural: 'social media managers',
  },
  85: {
    name: 'Production Manager',
    altName: 'production management',
    plural: 'production managers',
  },
  86: {
    name: 'Production Coordinator',
    altName: 'production coordination',
    plural: 'production coordinators',
  },
  87: {
    name: 'First Assistant Camera',
    altName: 'first assistant camera',
    plural: 'first assistant cameras',
  },
  88: {
    name: 'Second Assistant Camera',
    altName: 'second assistant camera',
    plural: 'second assistant cameras',
  },
  89: {
    name: 'Data Wrangler',
    altName: 'data wrangling',
    plural: 'data wranglers',
  },
  90: {
    name: 'Digital Imaging Technician (DIT)',
    altName: 'digital imaging',
    plural: 'digital imaging technicians',
  },
  91: {
    name: 'Gimbal Operator',
    altName: 'gimbal operation',
    plural: 'gimbal operators',
  },
  92: {
    name: 'Assistant Drone Pilot',
    altName: 'assistant drone piloting',
    plural: 'assistant drone pilots',
  },
  93: {
    name: 'Motion Control Technician/Operator',
    altName: 'motion control',
    plural: 'motion control technicians/operators',
  },
  94: {
    name: 'Audio Technician',
    altName: 'audio technology',
    plural: 'audio technicians',
  },
  95: {
    name: 'Audio Mixer - Recordist',
    altName: 'audio mixing',
    plural: 'audio mixers',
  },
  96: {
    name: 'Key Grip',
    altName: 'key grip',
    plural: 'key grips',
  },
  97: {
    name: 'Best Boy (Grip)',
    altName: 'best boy',
    plural: 'best boys (grip)',
  },
  98: {
    name: 'Dolly Grip',
    altName: 'dolly grip',
    plural: 'dolly grips',
  },
  100: {
    name: 'Best Boy (Electric)',
    altName: 'best boy',
    plural: 'best boys (electric)',
  },
  101: {
    name: 'Lighting Technician',
    altName: 'lighting',
    plural: 'lighting technicians',
  },
  102: {
    name: 'Set Designer',
    altName: 'set design',
    plural: 'set designers',
  },
  103: {
    name: 'Set Decorator',
    altName: 'set decoration',
    plural: 'set decorators',
  },
  104: {
    name: 'Set Dresser',
    altName: 'set dressing',
    plural: 'set dressers',
  },
  105: {
    name: 'Props Master',
    altName: 'props',
    plural: 'props masters',
  },
  106: {
    name: 'Props Builder',
    altName: 'props',
    plural: 'props builders',
  },
  107: {
    name: 'Armourer',
    altName: 'armoury',
    plural: 'armourers',
  },
  108: {
    name: 'Greensman',
    altName: 'greens',
    plural: 'greensmen',
  },
  109: {
    name: 'Construction Coordinator',
    altName: 'construction coordination',
    plural: 'construction coordinators',
  },
  110: {
    name: 'Casting Director',
    altName: 'casting',
    plural: 'casting directors',
  },
  111: {
    name: 'Talent Manager',
    altName: 'talent',
    plural: 'talent managers',
  },
  112: {
    name: 'Stunt Coordinator',
    altName: 'stunt coordination',
    plural: 'stunt coordinators',
  },
  113: {
    name: 'Dance Coordinator',
    altName: 'dance coordination',
    plural: 'dance coordinators',
  },
  114: {
    name: 'Model',
    altName: 'modeling',
    plural: 'models',
  },
  115: {
    name: 'Musician',
    altName: 'music',
    plural: 'musicians',
  },
  116: {
    name: 'Extra / Talent',
    altName: 'talent',
    plural: 'extras',
  },
  117: {
    name: 'Costume Designer - Stylist',
    altName: 'costume design',
    plural: 'costume designers - stylists',
  },
  118: {
    name: 'Cutter / Fitter',
    altName: 'cutting/fitting',
    plural: 'cutters / fitters',
  },
  119: {
    name: 'Hairdresser',
    altName: 'hairdressing',
    plural: 'hairdressers',
  },
  120: {
    name: 'Caterer / Craft Services',
    altName: 'catering',
    plural: 'caterers / craft services',
  },
  121: {
    name: 'Post Production Supervisor',
    altName: 'post production supervision',
    plural: 'post production supervisors',
  },
  122: {
    name: 'VFX Supervisor',
    altName: 'VFX supervision',
    plural: 'VFX supervisors',
  },
  123: {
    name: 'VFX Editor',
    altName: 'VFX editing',
    plural: 'VFX editors',
  },
  124: {
    name: 'Compositor',
    altName: 'compositing',
    plural: 'compositors',
  },
  125: {
    name: 'Rotoscope Artist',
    altName: 'rotoscoping',
    plural: 'rotoscope artists',
  },
  126: {
    name: 'Retoucher',
    altName: 'retouching',
    plural: 'retouchers',
  },
  127: {
    name: 'Sound Designer',
    altName: 'sound design',
    plural: 'sound designers',
  },
  128: {
    name: 'Sound Editor',
    altName: 'sound editing',
    plural: 'sound editors',
  },
  129: {
    name: 'Sound Mixer',
    altName: 'sound mixing',
    plural: 'sound mixers',
  },
  130: {
    name: 'Music Supervisor',
    altName: 'music supervision',
    plural: 'music supervisors',
  },
  131: {
    name: 'Music Composer',
    altName: 'music composition',
    plural: 'music composers',
  },
  132: {
    name: 'Music Producer',
    altName: 'music production',
    plural: 'music producers',
  },
  133: {
    name: 'Fabrication Company',
    altName: 'fabrication company',
    plural: 'fabrication companies',
  },
  134: {
    name: 'Advertising Agency',
    altName: 'advertising agency',
    plural: 'advertising agencies',
  },
  135: {
    name: 'Production Studio',
    altName: 'production studio',
    plural: 'production studios',
  },
  136: {
    name: 'Marketing Agency',
    altName: 'marketing agency',
    plural: 'marketing agencies',
  },
  137: {
    name: 'Social Media Agency',
    altName: 'social media agency',
    plural: 'social media agencies',
  },
  138: {
    name: 'Media Agency',
    altName: 'media agency',
    plural: 'media agencies',
  },
  139: {
    name: 'Event Marketing Agency',
    altName: 'event marketing agency',
    plural: 'event marketing agencies',
  },
  140: {
    name: 'Digital Creator',
    altName: 'digital creation',
    plural: 'digital creators',
  },
  141: {
    name: 'Influencer',
    altName: 'influencer',
    plural: 'influencers',
  },
  142: {
    name: 'Business',
    altName: 'business',
    plural: 'businesses',
  },
  143: {
    name: 'Choreographer',
    altName: 'choreography',
    plural: 'choreographers',
  },
  144: {
    name: 'Director of Social Media',
    altName: 'social media direction',
    plural: 'directors of social media',
  },
  145: {
    name: 'Senior Social Media Manager',
    altName: 'social media management',
    plural: 'senior social media managers',
  },
  146: {
    name: 'Digital Producer',
    altName: 'digital production',
    plural: 'digital producers',
  },
  148: {
    name: 'Director of Design',
    altName: 'design direction',
    plural: 'directors of design',
  },
  149: {
    name: 'Make-Up Artist',
    altName: 'makeup',
    plural: 'make-up artists',
  },
  150: {
    name: 'Freelance Designer',
    altName: 'freelance design',
    plural: 'freelance designers',
  },
  151: {
    name: 'Journalist',
    altName: 'journalism',
    plural: 'journalists',
  },
  152: {
    name: 'Researcher',
    altName: 'research',
    plural: 'researchers',
  },
  155: {
    name: 'Social Media Intern',
    altName: 'social media',
    plural: 'social media interns',
  },
  156: {
    name: 'Social Media Specialist',
    altName: 'social media',
    plural: 'social media specialists',
  },
  157: {
    name: 'Social Media Coordinator',
    altName: 'social media coordination',
    plural: 'social media coordinators',
  },
  158: {
    name: 'Social Media Assistant',
    altName: 'social media',
    plural: 'social media assistants',
  },
  159: {
    name: 'Photo Editor',
    altName: 'photo editing',
    plural: 'photo editors',
  },
  160: {
    name: 'University',
    altName: 'university',
    plural: 'universities',
  },
  161: {
    name: 'Colorist',
    altName: 'color',
    plural: 'colorists',
  },
  162: {
    name: 'Creative Media Manager',
    altName: 'creative media management',
    plural: 'creative media managers',
  },
  163: {
    name: 'Newspaper',
    altName: 'newspaper',
    plural: 'newspapers',
  },
  164: {
    name: 'Reporter/Journalist',
    altName: 'journalism',
    plural: 'reporters/journalists',
  },
  166: {
    name: 'Coach',
    altName: 'coaching',
    plural: 'coaches',
  },
  167: {
    name: 'Assistant Director of Social',
    altName: 'social direction',
    plural: 'assistant directors of social',
  },
  168: {
    name: 'Event',
    altName: 'event',
    plural: 'events',
  },
  169: {
    name: 'Assistant Choreographer',
    altName: 'choreography',
    plural: 'assistant choreographers',
  },
  170: {
    name: 'Associate Choreographer',
    altName: 'choreography',
    plural: 'associate choreographers',
  },
  171: {
    name: 'Senior Producer',
    altName: 'production',
    plural: 'senior producers',
  },
  172: {
    name: 'Video Director',
    altName: 'video direction',
    plural: 'video directors',
  },
  173: {
    name: 'Community Manager',
    altName: 'community management',
    plural: 'community managers',
  },
  174: {
    name: 'Website Manager',
    altName: 'website management',
    plural: 'website managers',
  },
  175: {
    name: 'Photography Intern',
    altName: 'photography',
    plural: 'photography interns',
  },
  176: {
    name: 'Photography Assistant',
    altName: 'photography',
    plural: 'photography assistants',
  },
  177: {
    name: 'Marketing Director',
    altName: 'marketing direction',
    plural: 'marketing directors',
  },
  180: {
    name: 'News Magazine',
    altName: 'news magazine',
    plural: 'news magazines',
  },
  181: {
    name: 'Athletic Department',
    altName: 'athletic department',
    plural: 'athletic departments',
  },
  182: {
    name: 'Radio Station',
    altName: 'radio station',
    plural: 'radio stations',
  },
  183: {
    name: 'Automotive Company',
    altName: 'automotive company',
    plural: 'automotive companies',
  },
  184: {
    name: 'Communications Director',
    altName: 'communications direction',
    plural: 'communications directors',
  },
  185: {
    name: 'Sports Trainer',
    altName: 'sports training',
    plural: 'sports trainers',
  },
  186: {
    name: 'Fitness Trainer',
    altName: 'fitness training',
    plural: 'fitness trainers',
  },
  187: {
    name: 'Video Intern',
    altName: 'video',
    plural: 'video interns',
  },
  188: {
    name: 'Director of Creative Content',
    altName: 'creative content direction',
    plural: 'directors of creative content',
  },
  189: {
    name: 'Marketing Manager',
    altName: 'marketing management',
    plural: 'marketing managers',
  },
  190: {
    name: 'Magazine',
    altName: 'magazine',
    plural: 'magazines',
  },
  191: {
    name: 'Co-Director',
    altName: 'directing',
    plural: 'co-directors',
  },
  192: {
    name: 'Dance Team',
    altName: 'dance team',
    plural: 'dance teams',
  },
  193: {
    name: 'Performer',
    altName: 'performance',
    plural: 'performers',
  },
  194: {
    name: 'Assistant Editor',
    altName: 'editing',
    plural: 'assistant editors',
  },
  195: {
    name: 'TV Show',
    altName: 'TV show',
    plural: 'TV shows',
  },
  197: {
    name: 'Agent',
    altName: 'agent',
    plural: 'agents',
  },
  198: {
    name: 'Content Manager',
    altName: 'content management',
    plural: 'content managers',
  },
  199: {
    name: 'Graphic Design Intern',
    altName: 'graphic design',
    plural: 'graphic design interns',
  },
  200: {
    name: 'Digital Partnerships Manager',
    altName: 'digital partnerships',
    plural: 'digital partnerships managers',
  },
  201: {
    name: 'Creative Media Intern',
    altName: 'creative media',
    plural: 'creative media interns',
  },
  202: {
    name: 'Rhinestone Designer',
    altName: 'rhinestone design',
    plural: 'rhinestone designers',
  },
  203: {
    name: 'Music Label',
    altName: 'music label',
    plural: 'music labels',
  },
  204: {
    name: 'Players Association',
    altName: 'players association',
    plural: 'players associations',
  },
  205: {
    name: 'Sports Tournament',
    altName: 'sports tournament',
    plural: 'sports tournaments',
  },
  206: {
    name: 'Sports Information Assistant',
    altName: 'sports information',
    plural: 'sports information assistants',
  },
  207: {
    name: 'Professional Hockey League',
    altName: 'professional hockey league',
    plural: 'professional hockey leagues',
  },
  208: {
    name: '3D Printing Company',
    altName: '3D printing company',
    plural: '3D printing companies',
  },
  209: {
    name: 'Aerospace Manufacturer',
    altName: 'aerospace manufacturer',
    plural: 'aerospace manufacturers',
  },
  210: {
    name: 'Airline',
    altName: 'airline',
    plural: 'airlines',
  },
  211: {
    name: 'Amateur Basketball Trainer',
    altName: 'amateur basketball training',
    plural: 'amateur basketball trainers',
  },
  212: {
    name: 'Amateur Football Trainer',
    altName: 'amateur football training',
    plural: 'amateur football trainers',
  },
  213: {
    name: 'Athletic Apparel Brand',
    altName: 'athletic apparel brand',
    plural: 'athletic apparel brands',
  },
  214: {
    name: 'Author',
    altName: 'writing',
    plural: 'authors',
  },
  215: {
    name: 'Band',
    altName: 'band',
    plural: 'bands',
  },
  216: {
    name: 'Bank',
    altName: 'bank',
    plural: 'banks',
  },
  217: {
    name: 'Beauty & Makeup Brand',
    altName: 'beauty & makeup brand',
    plural: 'beauty & makeup brands',
  },
  218: {
    name: 'Beer',
    altName: 'beer',
    plural: 'beers',
  },
  219: {
    name: 'Beverage Brand',
    altName: 'beverage brand',
    plural: 'beverage brands',
  },
  220: {
    name: 'British Television Network',
    altName: 'british television network',
    plural: 'british television networks',
  },
  221: {
    name: 'Building Design Company',
    altName: 'building design company',
    plural: 'building design companies',
  },
  222: {
    name: 'Building Supply Retailer',
    altName: 'building supply retailer',
    plural: 'building supply retailers',
  },
  223: {
    name: 'Camper Truck Brand',
    altName: 'camper truck brand',
    plural: 'camper truck brands',
  },
  224: {
    name: 'Candy',
    altName: 'candy',
    plural: 'candies',
  },
  225: {
    name: 'Car Brand',
    altName: 'car brand',
    plural: 'car brands',
  },
  226: {
    name: 'Car Dealership',
    altName: 'car dealership',
    plural: 'car dealerships',
  },
  227: {
    name: 'Charity',
    altName: 'charity',
    plural: 'charities',
  },
  228: {
    name: 'Chef',
    altName: 'cooking',
    plural: 'chefs',
  },
  229: {
    name: 'Chewing Gum Brand',
    altName: 'chewing gum brand',
    plural: 'chewing gum brands',
  },
  230: {
    name: 'Children\'s Television Network',
    altName: 'children\'s television network',
    plural: 'children\'s television networks',
  },
  232: {
    name: 'Cinema Technology Brand',
    altName: 'cinema technology brand',
    plural: 'cinema technology brands',
  },
  233: {
    name: 'Clothing Brand',
    altName: 'clothing brand',
    plural: 'clothing brands',
  },
  234: {
    name: 'Clothing Retailer',
    altName: 'clothing retailer',
    plural: 'clothing retailers',
  },
  235: {
    name: 'Coding Service',
    altName: 'coding service',
    plural: 'coding services',
  },
  236: {
    name: 'College Football Tournament',
    altName: 'college football tournament',
    plural: 'college football tournaments',
  },
  237: {
    name: 'Comedian',
    altName: 'comedy',
    plural: 'comedians',
  },
  238: {
    name: 'Convenience Store',
    altName: 'convenience store',
    plural: 'convenience stores',
  },
  239: {
    name: 'Creative Software',
    altName: 'creative software',
    plural: 'creative software',
  },
  240: {
    name: 'Credit Card',
    altName: 'credit card',
    plural: 'credit cards',
  },
  241: {
    name: 'Dancer',
    altName: 'dance',
    plural: 'dancers',
  },
  242: {
    name: 'Department Store',
    altName: 'department store',
    plural: 'department stores',
  },
  243: {
    name: 'DJ',
    altName: 'DJing',
    plural: 'DJs',
  },
  244: {
    name: 'EDM Artist',
    altName: 'EDM',
    plural: 'EDM artists',
  },
  245: {
    name: 'Energy Producer',
    altName: 'energy producer',
    plural: 'energy producers',
  },
  246: {
    name: 'Entrepreneur',
    altName: 'entrepreneurship',
    plural: 'entrepreneurs',
  },
  247: {
    name: 'Eyewear Brand',
    altName: 'eyewear brand',
    plural: 'eyewear brands',
  },
  248: {
    name: 'F1 Driver',
    altName: 'F1 driving',
    plural: 'F1 drivers',
  },
  249: {
    name: 'Fertilizer',
    altName: 'fertilizer',
    plural: 'fertilizers',
  },
  251: {
    name: 'Filmmaker',
    altName: 'filmmaking',
    plural: 'filmmakers',
  },
  252: {
    name: 'Financial Service',
    altName: 'financial service',
    plural: 'financial services',
  },
  253: {
    name: 'Fitness & Lifestyle Brand',
    altName: 'fitness & lifestyle brand',
    plural: 'fitness & lifestyle brands',
  },
  254: {
    name: 'Food & Snack Brand',
    altName: 'food & snack brand',
    plural: 'food & snack brands',
  },
  255: {
    name: 'Fundraising Service',
    altName: 'fundraising service',
    plural: 'fundraising services',
  },
  257: {
    name: 'Furniture Retailer',
    altName: 'furniture retailer',
    plural: 'furniture retailers',
  },
  258: {
    name: 'Gaming Developer',
    altName: 'game development',
    plural: 'gaming developers',
  },
  259: {
    name: 'Gaming Product',
    altName: 'gaming product',
    plural: 'gaming products',
  },
  260: {
    name: 'Golf Equipment Brand',
    altName: 'golf equipment brand',
    plural: 'golf equipment brands',
  },
  261: {
    name: 'Grocery Store',
    altName: 'grocery store',
    plural: 'grocery stores',
  },
  262: {
    name: 'Audio Equipment Brand',
    altName: 'audio equipment brand',
    plural: 'audio equipment brands',
  },
  263: {
    name: 'Host',
    altName: 'hosting',
    plural: 'hosts',
  },
  264: {
    name: 'Hotel & Resort',
    altName: 'hotel & resort',
    plural: 'hotel & resorts',
  },
  265: {
    name: 'Ice Cream Brand',
    altName: 'ice cream brand',
    plural: 'ice cream brands',
  },
  267: {
    name: 'Insurance Company',
    altName: 'insurance company',
    plural: 'insurance companies',
  },
  268: {
    name: 'Professional Golf Organization',
    altName: 'professional golf organization',
    plural: 'professional golf organizations',
  },
  269: {
    name: 'International Major Tennis Event',
    altName: 'international major tennis event',
    plural: 'international major tennis events',
  },
  270: {
    name: 'International Men\'s Professional Basketball Team',
    altName: 'international men\'s professional basketball team',
    plural: 'international men\'s professional basketball teams',
  },
  271: {
    name: 'International Professional Golf Tour',
    altName: 'international professional golf tour',
    plural: 'international professional golf tours',
  },
  272: {
    name: 'International Professional Racing League',
    altName: 'international professional racing league',
    plural: 'international professional racing leagues',
  },
  273: {
    name: 'International Women\'s Professional Basketball Team',
    altName: 'international women\'s professional basketball team',
    plural: 'international women\'s professional basketball teams',
  },
  274: {
    name: 'Investment Firm',
    altName: 'investment firm',
    plural: 'investment firms',
  },
  275: {
    name: 'Jewelry Brand',
    altName: 'jewelry brand',
    plural: 'jewelry brands',
  },
  277: {
    name: 'Kitchen Appliance',
    altName: 'kitchen appliance',
    plural: 'kitchen appliances',
  },
  278: {
    name: 'Magician',
    altName: 'magic',
    plural: 'magicians',
  },
  279: {
    name: 'Media Personality',
    altName: 'media personality',
    plural: 'media personalities',
  },
  280: {
    name: 'Media Production Company',
    altName: 'media production company',
    plural: 'media production companies',
  },
  281: {
    name: 'MLB Player',
    altName: 'MLB player',
    plural: 'MLB players',
  },
  282: {
    name: 'MLB Team',
    altName: 'MLB team',
    plural: 'MLB teams',
  },
  283: {
    name: 'MLS Player',
    altName: 'MLS player',
    plural: 'MLS players',
  },
  284: {
    name: 'MLS Team',
    altName: 'MLS team',
    plural: 'MLS teams',
  },
  286: {
    name: 'Motorcycle Brand',
    altName: 'motorcycle brand',
    plural: 'motorcycle brands',
  },
  287: {
    name: 'Music Streaming Service',
    altName: 'music streaming service',
    plural: 'music streaming services',
  },
  289: {
    name: 'NASCAR Driver',
    altName: 'NASCAR driving',
    plural: 'NASCAR drivers',
  },
  290: {
    name: 'NBA G League Team',
    altName: 'NBA G league team',
    plural: 'NBA G league teams',
  },
  291: {
    name: 'NBA Player',
    altName: 'NBA player',
    plural: 'NBA players',
  },
  292: {
    name: 'NBA Team',
    altName: 'NBA team',
    plural: 'NBA teams',
  },
  293: {
    name: 'NCAA Football Team',
    altName: 'NCAA football team',
    plural: 'NCAA football teams',
  },
  294: {
    name: 'NCAA Division 2 Women\'s Ski Team',
    altName: 'NCAA division 2 women\'s ski team',
    plural: 'NCAA division 2 women\'s ski teams',
  },
  295: {
    name: 'NCAA Division 2 Men\'s Ski Team',
    altName: 'NCAA division 2 men\'s ski team',
    plural: 'NCAA division 2 men\'s ski teams',
  },
  296: {
    name: 'NCAA Men\'s Baseball Team',
    altName: 'NCAA men\'s baseball team',
    plural: 'NCAA men\'s baseball teams',
  },
  297: {
    name: 'NCAA Men\'s Basketball Team',
    altName: 'NCAA men\'s basketball team',
    plural: 'NCAA men\'s basketball teams',
  },
  298: {
    name: 'NCAA Men\'s College Basketball Tournament',
    altName: 'NCAA men\'s college basketball tournament',
    plural: 'NCAA men\'s college basketball tournaments',
  },
  299: {
    name: 'NCAA Women\'s College Basketball Tournament',
    altName: 'NCAA women\'s college basketball tournament',
    plural: 'NCAA women\'s college basketball tournaments',
  },
  300: {
    name: 'NCAA Women\'s Basketball Team',
    altName: 'NCAA women\'s basketball team',
    plural: 'NCAA women\'s basketball teams',
  },
  301: {
    name: 'NCAA Women\'s Softball League',
    altName: 'NCAA women\'s softball league',
    plural: 'NCAA women\'s softball leagues',
  },
  302: {
    name: 'NCAA Women\'s Soccer Team',
    altName: 'NCAA women\'s soccer team',
    plural: 'NCAA women\'s soccer teams',
  },
  303: {
    name: 'NFL Coach',
    altName: 'NFL coaching',
    plural: 'NFL coaches',
  },
  304: {
    name: 'NFL Player',
    altName: 'NFL player',
    plural: 'NFL players',
  },
  305: {
    name: 'NFL Team',
    altName: 'NFL team',
    plural: 'NFL teams',
  },
  306: {
    name: 'NFT Creator',
    altName: 'NFT creation',
    plural: 'NFT creators',
  },
  307: {
    name: 'NHL Player',
    altName: 'NHL player',
    plural: 'NHL players',
  },
  308: {
    name: 'NHL Team',
    altName: 'NHL team',
    plural: 'NHL teams',
  },
  309: {
    name: 'NWSL Player',
    altName: 'NWSL player',
    plural: 'NWSL players',
  },
  310: {
    name: 'NWSL Team',
    altName: 'NWSL team',
    plural: 'NWSL teams',
  },
  311: {
    name: 'Off-Road Vehicle Brand',
    altName: 'off-road vehicle brand',
    plural: 'off-road vehicle brands',
  },
  312: {
    name: 'Office Supply Retailer',
    altName: 'office supply retailer',
    plural: 'office supply retailers',
  },
  313: {
    name: 'Olympic Team',
    altName: 'olympic team',
    plural: 'olympic teams',
  },
  314: {
    name: 'Online Marketplace',
    altName: 'online marketplace',
    plural: 'online marketplaces',
  },
  315: {
    name: 'Online Service',
    altName: 'online service',
    plural: 'online services',
  },
  316: {
    name: 'Outdoor Lifestyle Brand',
    altName: 'outdoor lifestyle brand',
    plural: 'outdoor lifestyle brands',
  },
  317: {
    name: 'Payment Service',
    altName: 'payment service',
    plural: 'payment services',
  },
  318: {
    name: 'Personal Business Service',
    altName: 'personal business service',
    plural: 'personal business services',
  },
  319: {
    name: 'PGA Tour Player',
    altName: 'PGA tour player',
    plural: 'PGA tour players',
  },
  320: {
    name: 'Phone Brand',
    altName: 'phone brand',
    plural: 'phone brands',
  },
  321: {
    name: 'Phone Service Company',
    altName: 'phone service company',
    plural: 'phone service companies',
  },
  323: {
    name: 'Pop Culture Retailer',
    altName: 'pop culture retailer',
    plural: 'pop culture retailers',
  },
  324: {
    name: 'Premier League Player',
    altName: 'premier league player',
    plural: 'premier league players',
  },
  325: {
    name: 'Premier League Team',
    altName: 'premier league team',
    plural: 'premier league teams',
  },
  326: {
    name: 'Professional Auto Racing League',
    altName: 'professional auto racing league',
    plural: 'professional auto racing leagues',
  },
  327: {
    name: 'Professional Baseball League',
    altName: 'professional baseball league',
    plural: 'professional baseball leagues',
  },
  328: {
    name: 'Professional Basketball League',
    altName: 'professional basketball league',
    plural: 'professional basketball leagues',
  },
  330: {
    name: 'Professional Boxer',
    altName: 'professional boxing',
    plural: 'professional boxers',
  },
  331: {
    name: 'Professional Bull Riding League',
    altName: 'professional bull riding league',
    plural: 'professional bull riding leagues',
  },
  332: {
    name: 'Professional Cyclist',
    altName: 'professional cycling',
    plural: 'professional cyclists',
  },
  333: {
    name: 'Professional Diver',
    altName: 'professional diving',
    plural: 'professional divers',
  },
  334: {
    name: 'Professional Football League',
    altName: 'professional football league',
    plural: 'professional football leagues',
  },
  337: {
    name: 'Professional MMA Fighter',
    altName: 'professional MMA fighting',
    plural: 'professional MMA fighters',
  },
  338: {
    name: 'Professional MMA League',
    altName: 'professional MMA league',
    plural: 'professional MMA leagues',
  },
  339: {
    name: 'Professional Runner',
    altName: 'professional running',
    plural: 'professional runners',
  },
  340: {
    name: 'Professional Skater',
    altName: 'professional skating',
    plural: 'professional skaters',
  },
  341: {
    name: 'Professional Soccer League',
    altName: 'professional soccer league',
    plural: 'professional soccer leagues',
  },
  342: {
    name: 'Professional Soccer Player',
    altName: 'professional soccer player',
    plural: 'professional soccer players',
  },
  343: {
    name: 'Professional Tennis Player',
    altName: 'professional tennis player',
    plural: 'professional tennis players',
  },
  344: {
    name: 'Professional Women\'s Basketball League',
    altName: 'professional women\'s basketball league',
    plural: 'professional women\'s basketball leagues',
  },
  345: {
    name: 'Professional Wrestler',
    altName: 'professional wrestling',
    plural: 'professional wrestlers',
  },
  346: {
    name: 'Rapper',
    altName: 'rap',
    plural: 'rappers',
  },
  347: {
    name: 'Real Estate Service',
    altName: 'real estate service',
    plural: 'real estate services',
  },
  348: {
    name: 'Record Label',
    altName: 'record label',
    plural: 'record labels',
  },
  349: {
    name: 'Reporter',
    altName: 'reporting',
    plural: 'reporters',
  },
  350: {
    name: 'Restaurant',
    altName: 'restaurant',
    plural: 'restaurants',
  },
  351: {
    name: 'Scientist',
    altName: 'science',
    plural: 'scientists',
  },
  352: {
    name: 'Singer',
    altName: 'singing',
    plural: 'singers',
  },
  353: {
    name: 'Internet Service Provider',
    altName: 'internet service provider',
    plural: 'internet service providers',
  },
  355: {
    name: 'Sneaker Service',
    altName: 'sneaker service',
    plural: 'sneaker services',
  },
  356: {
    name: 'Soccer Broadcasting Agency',
    altName: 'soccer broadcasting agency',
    plural: 'soccer broadcasting agencies',
  },
  358: {
    name: 'Sports Agency',
    altName: 'sports agency',
    plural: 'sports agencies',
  },
  359: {
    name: 'Sports Analyst',
    altName: 'sports analysis',
    plural: 'sports analysts',
  },
  360: {
    name: 'Sports Betting Service',
    altName: 'sports betting service',
    plural: 'sports betting services',
  },
  362: {
    name: 'Sports Media Outlet',
    altName: 'sports media outlet',
    plural: 'sports media outlets',
  },
  363: {
    name: 'Sports Television Network',
    altName: 'sports television network',
    plural: 'sports television networks',
  },
  364: {
    name: 'Streaming Service',
    altName: 'streaming service',
    plural: 'streaming services',
  },
  366: {
    name: 'Technology Brand',
    altName: 'technology brand',
    plural: 'technology brands',
  },
  367: {
    name: 'Technology Retailer',
    altName: 'technology retailer',
    plural: 'technology retailers',
  },
  368: {
    name: 'Watch Brand',
    altName: 'watch brand',
    plural: 'watch brands',
  },
  369: {
    name: 'Toothpaste',
    altName: 'toothpaste',
    plural: 'toothpastes',
  },
  370: {
    name: 'Toy Brand',
    altName: 'toy brand',
    plural: 'toy brands',
  },
  371: {
    name: 'Transportation Service',
    altName: 'transportation service',
    plural: 'transportation services',
  },
  372: {
    name: 'Travel Agency',
    altName: 'travel agency',
    plural: 'travel agencies',
  },
  373: {
    name: 'Travel Blog',
    altName: 'travel blog',
    plural: 'travel blogs',
  },
  374: {
    name: 'Twitch Streamer',
    altName: 'twitch streaming',
    plural: 'twitch streamers',
  },
  375: {
    name: 'Typeface Design',
    altName: 'typeface design',
    plural: 'typeface designs',
  },
  376: {
    name: 'UFC Fighter',
    altName: 'UFC fighting',
    plural: 'UFC fighters',
  },
  378: {
    name: 'Video Game',
    altName: 'video game',
    plural: 'video games',
  },
  379: {
    name: 'Video Game Retailer',
    altName: 'video game retailer',
    plural: 'video game retailers',
  },
  380: {
    name: 'WNBA Player',
    altName: 'WNBA player',
    plural: 'WNBA players',
  },
  381: {
    name: 'WNBA Team',
    altName: 'WNBA team',
    plural: 'WNBA teams',
  },
  382: {
    name: 'YouTuber',
    altName: 'YouTube content creation',
    plural: 'YouTubers',
  },
  383: {
    name: 'College Athletics Department',
    altName: 'college athletics department',
    plural: 'college athletics departments',
  },
  384: {
    name: 'NCAA Men\'s Soccer Team',
    altName: 'NCAA men\'s soccer team',
    plural: 'NCAA men\'s soccer teams',
  },
  386: {
    name: 'Sports Creative Agency',
    altName: 'sports creative agency',
    plural: 'sports creative agencies',
  },
  388: {
    name: 'Athletic Apparel',
    altName: 'athletic apparel',
    plural: 'athletic apparel',
  },
  389: {
    name: 'Founder',
    altName: 'founding',
    plural: 'founders',
  },
  391: {
    name: 'Business News Outlet',
    altName: 'business news outlet',
    plural: 'business news outlets',
  },
  392: {
    name: 'Camper Truck',
    altName: 'camper truck',
    plural: 'camper trucks',
  },
  393: {
    name: 'Childrens Television Network',
    altName: 'children\'s television network',
    plural: 'children\'s television networks',
  },
  394: {
    name: 'Cinema Technology Production',
    altName: 'cinema technology production',
    plural: 'cinema technology productions',
  },
  396: {
    name: 'Energy Provider',
    altName: 'energy provider',
    plural: 'energy providers',
  },
  399: {
    name: 'Financial Technology Brand',
    altName: 'financial technology brand',
    plural: 'financial technology brands',
  },
  401: {
    name: 'House Rental Service',
    altName: 'house rental service',
    plural: 'house rental services',
  },
  402: {
    name: 'International Golfers Association',
    altName: 'international golfers association',
    plural: 'international golfers associations',
  },
  404: {
    name: 'Motorcyle Brand',
    altName: 'motorcycle brand',
    plural: 'motorcycle brands',
  },
  405: {
    name: 'Music Promotion',
    altName: 'music promotion',
    plural: 'music promotions',
  },
  406: {
    name: 'NCAA Divison 2 Mens Ski Team',
    altName: 'NCAA division 2 mens ski team',
    plural: 'NCAA division 2 mens ski teams',
  },
  407: {
    name: 'NCAA Men\'s Division 1 Soccer Team',
    altName: 'NCAA men\'s division 1 soccer team',
    plural: 'NCAA men\'s division 1 soccer teams',
  },
  408: {
    name: 'NCAA Women\'s Divison 1 Softball League',
    altName: 'NCAA women\'s division 1 softball league',
    plural: 'NCAA women\'s division 1 softball leagues',
  },
  411: {
    name: 'Politician',
    altName: 'politics',
    plural: 'politicians',
  },
  412: {
    name: 'Professional Racer',
    altName: 'professional racing',
    plural: 'professional racers',
  },
  413: {
    name: 'Serie A Basketball Player',
    altName: 'serie A basketball player',
    plural: 'serie A basketball players',
  },
  414: {
    name: 'Service Provider',
    altName: 'service provider',
    plural: 'service providers',
  },
  417: {
    name: 'Timewatch Brand',
    altName: 'timewatch brand',
    plural: 'timewatch brands',
  },
  418: {
    name: 'U.S. Olympic + Paralympic Team',
    altName: 'U.S. olympic + paralympic team',
    plural: 'U.S. olympic + paralympic teams',
  },
  419: {
    name: 'Virtual Reality',
    altName: 'virtual reality',
    plural: 'virtual realities',
  },
  420: {
    name: 'Writer',
    altName: 'writing',
    plural: 'writers',
  },
  421: {
    name: 'Men\'s Professional Basketball League',
    altName: 'men\'s professional basketball league',
    plural: 'men\'s professional basketball leagues',
  },
  422: {
    name: 'NCAA Basketball Men\'s Team',
    altName: 'NCAA basketball men\'s team',
    plural: 'NCAA basketball men\'s teams',
  },
  423: {
    name: 'NCAA Division 1 Baseball Team',
    altName: 'NCAA division 1 baseball team',
    plural: 'NCAA division 1 baseball teams',
  },
  424: {
    name: 'MLS Soccer Team',
    altName: 'MLS soccer team',
    plural: 'MLS soccer teams',
  },
  425: {
    name: 'Twitter',
    altName: 'twitter',
    plural: 'Twitter',
  },
  427: {
    name: 'Big 10 Basketball Player',
    altName: 'big 10 basketball player',
    plural: 'big 10 basketball players',
  },
  428: {
    name: 'Professional Hockey Player',
    altName: 'professional hockey player',
    plural: 'professional hockey players',
  },
  429: {
    name: 'NFL Video Game',
    altName: 'NFL video game',
    plural: 'NFL video games',
  },
  430: {
    name: 'Basketball Apparel',
    altName: 'basketball apparel',
    plural: 'basketball apparel',
  },
  431: {
    name: 'NBA Video Game',
    altName: 'NBA video game',
    plural: 'NBA video games',
  },
  432: {
    name: 'Creative',
    altName: 'creative',
    plural: 'creatives',
  },
  433: {
    name: 'Pop Culture Outlet',
    altName: 'pop culture outlet',
    plural: 'pop culture outlets',
  },
  435: {
    name: 'Music Media Production Company',
    altName: 'music media production company',
    plural: 'music media production companies',
  },
  436: {
    name: 'Off-Road Vehicle',
    altName: 'off-road vehicle',
    plural: 'off-road vehicles',
  },
  437: {
    name: 'Headphones/Speakers',
    altName: 'headphones/speakers',
    plural: 'headphones/speakers',
  },
  438: {
    name: 'Golf News Outlet',
    altName: 'golf news outlet',
    plural: 'golf news outlets',
  },
  439: {
    name: 'Dealership',
    altName: 'dealership',
    plural: 'dealerships',
  },
  440: {
    name: 'College Basketball Team',
    altName: 'college basketball team',
    plural: 'college basketball teams',
  },
  441: {
    name: 'Mascot',
    altName: 'mascot',
    plural: 'mascots',
  },
  442: {
    name: 'College Football Team',
    altName: 'college football team',
    plural: 'college football teams',
  },
  443: {
    name: 'Professional Racing Team',
    altName: 'professional racing team',
    plural: 'professional racing teams',
  },
  444: {
    name: 'Podcast',
    altName: 'podcast',
    plural: 'podcasts',
  },
  445: {
    name: 'Programmer',
    altName: 'programming',
    plural: 'programmers',
  },
  446: {
    name: 'Video Editor',
    altName: 'video editing',
    plural: 'video editors',
  },
  447: {
    name: 'Visual Effects Supervisor',
    altName: 'visual effects supervision',
    plural: 'visual effects supervisors',
  },
  448: {
    name: 'Visual Effects Artist',
    altName: 'visual effects',
    plural: 'visual effects artists',
  },
  449: {
    name: 'Visual Effects Editor',
    altName: 'visual effects editing',
    plural: 'visual effects editors',
  },
  450: {
    name: 'Animator - 3D',
    altName: '3D animation',
    plural: '3D animators',
  },
  451: {
    name: 'Product Manager',
    altName: 'product management',
    plural: 'product managers',
  },
  452: {
    name: 'College Bowl Game',
    altName: 'college bowl game',
    plural: 'college bowl games',
  },
  453: {
    name: 'NCAA Gymnastics Team',
    altName: 'NCAA gymnastics team',
    plural: 'NCAA gymnastics teams',
  },
  454: {
    name: 'NCAA Swim Team',
    altName: 'NCAA swim team',
    plural: 'NCAA swim teams',
  },
  455: {
    name: 'AHL Team',
    altName: 'AHL team',
    plural: 'AHL teams',
  },
  456: {
    name: 'Broadcaster',
    altName: 'broadcasting',
    plural: 'broadcasters',
  },
  457: {
    name: 'NCAA Hockey Team',
    altName: 'NCAA hockey team',
    plural: 'NCAA hockey teams',
  },
  458: {
    name: 'WHL Team',
    altName: 'WHL team',
    plural: 'WHL teams',
  },
  459: {
    name: 'Social Media Strategist',
    altName: 'social media strategy',
    plural: 'social media strategists',
  },
  460: {
    name: 'Social Growth Lead',
    altName: 'social growth',
    plural: 'social growth leads',
  },
  461: {
    name: 'Partnership Coordinator',
    altName: 'partnership coordination',
    plural: 'partnership coordinators',
  },
  462: {
    name: 'Senior Social Media Coordinator',
    altName: 'social media coordination',
    plural: 'senior social media coordinators',
  },
  463: {
    name: 'NCAA Volleyball Team',
    altName: 'NCAA volleyball team',
    plural: 'NCAA volleyball teams',
  },
  464: {
    name: 'NCAA Men\'s Tennis Team',
    altName: 'NCAA men\'s tennis team',
    plural: 'NCAA men\'s tennis teams',
  },
  465: {
    name: 'NCAA Women\'s Tennis Team',
    altName: 'NCAA women\'s tennis team',
    plural: 'NCAA women\'s tennis teams',
  },
  466: {
    name: 'MiLB Team',
    altName: 'MiLB team',
    plural: 'MiLB teams',
  },
  467: {
    name: 'NCAA Softball Team',
    altName: 'NCAA softball team',
    plural: 'NCAA softball teams',
  },
  468: {
    name: 'NCAA Conference',
    altName: 'NCAA conference',
    plural: 'NCAA conferences',
  },
  469: {
    name: 'Stop Motion Animator',
    altName: 'stop motion animation',
    plural: 'stop motion animators',
  },
  470: {
    name: 'Club Sports Organization',
    altName: 'club sports organization',
    plural: 'club sports organizations',
  },
  471: {
    name: 'Marketing Executive',
    altName: 'marketing executive',
    plural: 'marketing executives',
  },
  472: {
    name: 'College Baseball Team',
    altName: 'college baseball team',
    plural: 'college baseball teams',
  },
  473: {
    name: 'Healthcare System',
    altName: 'healthcare system',
    plural: 'healthcare systems',
  },
  474: {
    name: 'Consultant',
    altName: 'consulting',
    plural: 'consultants',
  },
  475: {
    name: 'Replay Operator',
    altName: 'replay operation',
    plural: 'replay operators',
  },
  476: {
    name: 'Athletic Director',
    altName: 'athletic direction',
    plural: 'athletic directors',
  },
  477: {
    name: 'NCAA Wrestling Team',
    altName: 'NCAA wrestling team',
    plural: 'NCAA wrestling teams',
  },
  478: {
    name: 'NCAA Championship',
    altName: 'NCAA championship',
    plural: 'NCAA championships',
  },
  479: {
    name: 'Design Consultant',
    altName: 'design consulting',
    plural: 'design consultants',
  },
  480: {
    name: 'NCAA Men\'s Golf Team',
    altName: 'NCAA men\'s golf team',
    plural: 'NCAA men\'s golf teams',
  },
  481: {
    name: 'NCAA Women\'s Golf Team',
    altName: 'NCAA women\'s golf team',
    plural: 'NCAA women\'s golf teams',
  },
  482: {
    name: 'Television News Network',
    altName: 'television news network',
    plural: 'television news networks',
  },
  483: {
    name: 'Software Company',
    altName: 'software company',
    plural: 'software companies',
  },
  484: {
    name: 'NCAA Lacrosse Team',
    altName: 'NCAA lacrosse team',
    plural: 'NCAA lacrosse teams',
  },
  485: {
    name: 'School District',
    altName: 'school district',
    plural: 'school districts',
  },
  486: {
    name: 'CFL Team',
    altName: 'CFL team',
    plural: 'CFL teams',
  },
  487: {
    name: 'Marketing Intern',
    altName: 'marketing',
    plural: 'marketing interns',
  },
  488: {
    name: 'Director of Digital',
    altName: 'digital direction',
    plural: 'directors of digital',
  },
  489: {
    name: 'OHL Team',
    altName: 'OHL team',
    plural: 'OHL teams',
  },
  490: {
    name: 'Songwriter',
    altName: 'songwriting',
    plural: 'songwriters',
  },
  491: {
    name: 'Project Manager',
    altName: 'project management',
    plural: 'project managers',
  },
  492: {
    name: 'NCAA Men\'s Basketball Player',
    altName: 'NCAA men\'s basketball player',
    plural: 'NCAA men\'s basketball players',
  },
  493: {
    name: 'NCAA Women\'s Basketball Player',
    altName: 'NCAA women\'s basketball player',
    plural: 'NCAA women\'s basketball players',
  },
  494: {
    name: 'USL Soccer Team',
    altName: 'USL soccer team',
    plural: 'USL soccer teams',
  },
  495: {
    name: 'Communications Coordinator',
    altName: 'communications coordination',
    plural: 'communications coordinators',
  },
  496: {
    name: 'Professional Lacrosse League',
    altName: 'professional lacrosse league',
    plural: 'professional lacrosse leagues',
  },
  497: {
    name: 'PLL Club',
    altName: 'PLL club',
    plural: 'PLL clubs',
  },
  498: {
    name: 'NAIA Lacrosse Team',
    altName: 'NAIA lacrosse team',
    plural: 'NAIA lacrosse teams',
  },
  499: {
    name: 'MLR Team',
    altName: 'MLR team',
    plural: 'MLR teams',
  },
  500: {
    name: 'High School Basketball Player',
    altName: 'high school basketball player',
    plural: 'high school basketball players',
  },
  501: {
    name: 'High School Football Team',
    altName: 'high school football team',
    plural: 'high school football teams',
  },
  502: {
    name: 'NCAA Beach Volleyball Team',
    altName: 'NCAA beach volleyball team',
    plural: 'NCAA beach volleyball teams',
  },
  503: {
    name: 'NCAA Track & Field Team',
    altName: 'NCAA track & field team',
    plural: 'NCAA track & field teams',
  },
  504: {
    name: 'NASCAR Team',
    altName: 'NASCAR team',
    plural: 'NASCAR teams',
  },
  505: {
    name: 'High School Lacrosse Team',
    altName: 'high school lacrosse team',
    plural: 'high school lacrosse teams',
  },
  506: {
    name: 'High School Basketball Team',
    altName: 'high school basketball team',
    plural: 'high school basketball teams',
  },
  507: {
    name: 'Creative Services Manager',
    altName: 'creative services management',
    plural: 'creative services managers',
  },
  508: {
    name: 'Amateur Baseball League',
    altName: 'amateur baseball league',
    plural: 'amateur baseball leagues',
  },
  509: {
    name: 'Esports Team',
    altName: 'esports team',
    plural: 'esports teams',
  },
  510: {
    name: 'Summer Camp',
    altName: 'summer camp',
    plural: 'summer camps',
  },
  511: {
    name: 'Account Director',
    altName: 'account direction',
    plural: 'account directors',
  },
  512: {
    name: 'Music Festival',
    altName: 'music festival',
    plural: 'music festivals',
  },
  513: {
    name: 'Junior Golf Tour',
    altName: 'junior golf tour',
    plural: 'junior golf tours',
  },
  514: {
    name: 'Communications Intern',
    altName: 'communications',
    plural: 'communications interns',
  },
  515: {
    name: 'Public Relations Organization',
    altName: 'public relations organization',
    plural: 'public relations organizations',
  },
  516: {
    name: 'College Program',
    altName: 'college program',
    plural: 'college programs',
  },
  517: {
    name: 'Head of Influencer Marketing',
    altName: 'influencer marketing',
    plural: 'heads of influencer marketing',
  },
  518: {
    name: 'Professional Golf Tournament',
    altName: 'professional golf tournament',
    plural: 'professional golf tournaments',
  },
  519: {
    name: 'VP of Social Media',
    altName: 'social media',
    plural: 'VPs of social media',
  },
  520: {
    name: 'Head of Marketing',
    altName: 'marketing',
    plural: 'heads of marketing',
  },
  521: {
    name: 'Student Athlete Advisory Committee',
    altName: 'student athlete advisory committee',
    plural: 'student athlete advisory committees',
  },
  522: {
    name: 'NCAA Field Hockey Team',
    altName: 'NCAA field hockey team',
    plural: 'NCAA field hockey teams',
  },
  523: {
    name: 'Painter',
    altName: 'painting',
    plural: 'painters',
  },
  524: {
    name: 'NBL Player',
    altName: 'NBL player',
    plural: 'NBL players',
  },
  525: {
    name: 'NBL Team',
    altName: 'NBL team',
    plural: 'NBL teams',
  },
  526: {
    name: 'Thumbnail Designer',
    altName: 'thumbnail design',
    plural: 'thumbnail designers',
  },
  527: {
    name: 'School',
    altName: 'school',
    plural: 'schools',
  },
  528: {
    name: 'Social Programmer',
    altName: 'social programming',
    plural: 'social programmers',
  },
  529: {
    name: 'Translator',
    altName: 'translation',
    plural: 'translators',
  },
  530: {
    name: 'Social Lead',
    altName: 'social leadership',
    plural: 'social leaders',
  },
  531: {
    name: 'Creative Producer',
    altName: 'creative production',
    plural: 'creative producers',
  },
  532: {
    name: 'Associate Producer',
    altName: 'associate production',
    plural: 'associate producers',
  },
  533: {
    name: 'NCAA Rifle Team',
    altName: 'NCAA rifle team',
    plural: 'NCAA rifle teams',
  },
  534: {
    name: 'Championship Football Club',
    altName: 'championship football club',
    plural: 'championship football clubs',
  },
  535: {
    name: 'Television Network',
    altName: 'television network',
    plural: 'television networks',
  },
  536: {
    name: 'INDYCAR Driver',
    altName: 'INDYCAR driving',
    plural: 'INDYCAR drivers',
  },
  537: {
    name: 'Awards Organization',
    altName: 'awards organization',
    plural: 'awards organizations',
  },
  538: {
    name: 'Marketing Specialist',
    altName: 'marketing',
    plural: 'marketing specialists',
  },
  539: {
    name: 'Senior Social Media Strategist',
    altName: 'social media strategy',
    plural: 'senior social media strategists',
  },
  540: {
    name: 'Director of Partnerships',
    altName: 'partnership direction',
    plural: 'directors of partnerships',
  },
  541: {
    name: 'Bundesliga Team',
    altName: 'bundesliga team',
    plural: 'bundesliga teams',
  },
  542: {
    name: 'La Liga Team',
    altName: 'la liga team',
    plural: 'la liga teams',
  },
  543: {
    name: 'Irish Football Club',
    altName: 'irish football club',
    plural: 'irish football clubs',
  },
  544: {
    name: 'Mortgage Company',
    altName: 'mortgage company',
    plural: 'mortgage companies',
  },
  546: {
    name: 'Amateur Baseball Team',
    altName: 'amateur baseball team',
    plural: 'amateur baseball teams',
  },
  547: {
    name: 'NCAA Ski Team',
    altName: 'NCAA ski team',
    plural: 'NCAA ski teams',
  },
  548: {
    name: 'NCAA Rowing Team',
    altName: 'NCAA rowing team',
    plural: 'NCAA rowing teams',
  },
  549: {
    name: 'Venture Capital or Investment Firm',
    altName: 'venture capital or investment firm',
    plural: 'venture capital or investment firms',
  },
  550: {
    name: 'NCEA Equestrian Team',
    altName: 'NCEA equestrian team',
    plural: 'NCEA equestrian teams',
  },
  551: {
    name: 'Professional Lacrosse Team',
    altName: 'professional lacrosse team',
    plural: 'professional lacrosse teams',
  },
  552: {
    name: 'XFL Team',
    altName: 'XFL team',
    plural: 'XFL teams',
  },
  553: {
    name: '360 Camera Operator',
    altName: '360 camera operation',
    plural: '360 camera operators',
  },
  554: {
    name: 'Ski Pass',
    altName: 'ski pass',
    plural: 'ski passes',
  },
  555: {
    name: 'NCAA Football Player',
    altName: 'NCAA football player',
    plural: 'NCAA football players',
  },
  556: {
    name: 'MiLB Player',
    altName: 'MiLB player',
    plural: 'MiLB players',
  },
  558: {
    name: 'Prompt Engineer',
    altName: 'prompt engineering',
    plural: 'prompt engineers',
  },
  559: {
    name: 'High School Baseball Team',
    altName: 'high school baseball team',
    plural: 'high school baseball teams',
  },
  560: {
    name: 'High School',
    altName: 'high school',
    plural: 'high schools',
  },
  561: {
    name: 'MLS Next Pro Team',
    altName: 'MLS next pro team',
    plural: 'MLS next pro teams',
  },
  562: {
    name: 'USFL Team',
    altName: 'USFL team',
    plural: 'USFL teams',
  },
  563: {
    name: 'Professional Indoor Football Team',
    altName: 'professional indoor football team',
    plural: 'professional indoor football teams',
  },
  564: {
    name: 'Netball Team',
    altName: 'netball team',
    plural: 'netball teams',
  },
  565: {
    name: 'Sporting Development Academy',
    altName: 'sporting development academy',
    plural: 'sporting development academies',
  },
  566: {
    name: 'Amateur Baseball Player',
    altName: 'amateur baseball player',
    plural: 'amateur baseball players',
  },
  567: {
    name: 'High School Soccer Team',
    altName: 'high school soccer team',
    plural: 'high school soccer teams',
  },
  568: {
    name: 'NAIA Women\'s Soccer Team',
    altName: 'NAIA women\'s soccer team',
    plural: 'NAIA women\'s soccer teams',
  },
  569: {
    name: 'Therapist',
    altName: 'therapy',
    plural: 'therapists',
  },
  570: {
    name: 'NCAA Water Polo Team',
    altName: 'NCAA water polo team',
    plural: 'NCAA water polo teams',
  },
  571: {
    name: 'Planner',
    altName: 'planning',
    plural: 'planners',
  },
  572: {
    name: 'NAIA Men\'s Soccer Team',
    altName: 'NAIA men\'s soccer team',
    plural: 'NAIA men\'s soccer teams',
  },
  573: {
    name: 'NAIA Women\'s Volleyball Team',
    altName: 'NAIA women\'s volleyball team',
    plural: 'NAIA women\'s volleyball teams',
  },
  574: {
    name: 'NAIA Men\'s Volleyball Team',
    altName: 'NAIA men\'s volleyball team',
    plural: 'NAIA men\'s volleyball teams',
  },
  575: {
    name: 'Student Organization',
    altName: 'student organization',
    plural: 'student organizations',
  },
  576: {
    name: 'Analytics Lead',
    altName: 'analytics',
    plural: 'analytics leads',
  },
  577: {
    name: 'ACHA Hockey Team',
    altName: 'ACHA hockey team',
    plural: 'ACHA hockey teams',
  },
  578: {
    name: 'Junior Ice Hockey Team',
    altName: 'junior ice hockey team',
    plural: 'junior ice hockey teams',
  },
  579: {
    name: 'Military Unit',
    altName: 'military unit',
    plural: 'military units',
  },
  580: {
    name: 'Fraternity/Sorority',
    altName: 'fraternity/sorority',
    plural: 'fraternities/sororities',
  },
  581: {
    name: 'First Assistant Director',
    altName: 'first assistant direction',
    plural: 'first assistant directors',
  },
  582: {
    name: 'Rugby Team',
    altName: 'rugby team',
    plural: 'rugby teams',
  },
  583: {
    name: 'Cheer Team',
    altName: 'cheer team',
    plural: 'cheer teams',
  },
  584: {
    name: 'NAIA Conference',
    altName: 'NAIA conference',
    plural: 'NAIA conferences',
  },
  585: {
    name: 'Senior Social Media Producer',
    altName: 'social media production',
    plural: 'senior social media producers',
  },
  586: {
    name: 'ISMA Driver',
    altName: 'ISMA driving',
    plural: 'ISMA drivers',
  },
  587: {
    name: 'Political Party/Committee',
    altName: 'political party/committee',
    plural: 'political parties/committees',
  },
  588: {
    name: 'ECHL Team',
    altName: 'ECHL team',
    plural: 'ECHL teams',
  },
  589: {
    name: 'Radio Show',
    altName: 'radio show',
    plural: 'radio shows',
  },
  590: {
    name: 'Independent Professional Baseball Team',
    altName: 'independent professional baseball team',
    plural: 'independent professional baseball teams',
  },
  591: {
    name: 'PWHL Team',
    altName: 'PWHL team',
    plural: 'PWHL teams',
  },
  592: {
    name: 'Ski Resort',
    altName: 'ski resort',
    plural: 'ski resorts',
  },
  593: {
    name: 'Clothing Designer',
    altName: 'clothing design',
    plural: 'clothing designers',
  },
  594: {
    name: 'LPGA Player',
    altName: 'LPGA player',
    plural: 'LPGA players',
  },
  595: {
    name: 'Real Estate',
    altName: 'real estate',
    plural: 'real estate',
  },
  596: {
    name: 'Assistant Communications Director',
    altName: 'communications direction',
    plural: 'assistant communications directors',
  },
  597: {
    name: 'High School Volleyball Team',
    altName: 'high school volleyball team',
    plural: 'high school volleyball teams',
  },
  598: {
    name: 'High School Hockey Team',
    altName: 'high school hockey team',
    plural: 'high school hockey teams',
  },
  599: {
    name: 'LIV Golf Team',
    altName: 'LIV golf team',
    plural: 'LIV golf teams',
  },
  600: {
    name: 'Theatrical Production',
    altName: 'theatrical production',
    plural: 'theatrical productions',
  },
};
